import envcompany from 'envcompany';

export const routerConfig = {
    '/login': {
        title: `Login-${envcompany.baseName}`
    },
    '/reset-password': {
        title: `Reset Password-${envcompany.baseName}`
    },
    '/forget-password': {
        title: `Find Password-${envcompany.baseName}`
    },
    '/pages/password/update': {
        title: 'Change Password'
    },
    '/pages/app/appkey': {
        permission:['outer_faceid_manage_apikey'],
        title: 'AppKey'
    },
    '/pages/app/appkey/view/:id': {
        title: 'Appkey Check',
        permission:['outer_faceid_manage_apikey'],
        breadcrumb: [
            ['AppKey', '/pages/app/appkey'],
            ['Appkey Check']
        ]
    },
    '/pages/app/bundle': {
        title: 'Mobile Client',
        permission:['outer_faceid_check_bundle'],
    },
    '/pages/consumption': {
        title: 'Face Verification',
        permission:['outer_faceid_usage_report'],
        breadcrumb: [
            ['Face Verification'],
        ]
    },
    '/pages/ktp-consumption': {
        title: 'Indonesia ID card',
        permission:['outer_faceid_usage_report'],
        breadcrumb: [
            ['Indonesia ID card'],
        ]
    },'/pages/starscope-consumption': {
        title: 'StarScope',
        permission:['outer_faceid_usage_report'],
        breadcrumb: [
            ['StarScope'],
        ]
    },'/pages/app/bundle/new':{
        title: 'Mobile Client',
        permission:['outer_faceid_bundleid'],
        breadcrumb: [
            ['Mobile Client'],
        ]
    },'/pages/app/bundle/:id':{
        title: 'Mobile Client',
        permission:['outer_faceid_check_bundle'],
        breadcrumb: [
            ['Mobile Client'],
        ]
    },'/pages/app/bundle/:id/edit':{
        title: 'Mobile Client',
        permission:['outer_faceid_bundleid'],
        breadcrumb: [
            ['Mobile Client'],
        ]
    },'/pages/sdk-download':{
        title: 'SDK DOWNLOAD',
        permission:['outer_faceid_sdk_download'],
        breadcrumb: [
            ['SDK Download'],
        ]
    },'/pages/sdk-scenes':{
        title: 'SDK Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['SDK Config Scenes'],
        ]
    },'/pages/sdk-scenes/create':{
        title: 'SDK Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['SDK Config Scenes'],
        ]
    },'/pages/sdk-scenes/edit/:id':{
        title: 'SDK Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['SDK Config Scenes'],
        ]
    },'/pages/card-scenes':{
        title: 'Card SDK Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['Card SDK Scenes'],
        ]
    },'/pages/card-scenes/create':{
        title: 'Card SDK Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['Card SDK Scenes'],
        ]
    },'/pages/card-scenes/edit/:id':{
        title: 'Card SDK Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['Card SDK Scenes'],
        ]
    },'/pages/verify-scenes':{
        title: 'Verify Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['Verify Config Scenes'],
        ]
    },'/pages/verify-scenes/create':{
        title: 'Verify Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['Verify Config Scenes'],
        ]
    },'/pages/verify-scenes/edit/:id':{
        title: 'Verify Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['Verify Config Scenes'],
        ]
    },'/pages/encryption':{
        title: 'Encryption',
        permission:['outer_faceid_info_encrypt'],
        breadcrumb: [
            ['Encryption'],
        ]
    },'/pages/lite-scenes':{
        title: 'H5 Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['H5 Config Scenes'],
        ]
    },'/pages/lite-scenes/create':{
        title: 'H5 Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['H5 Config Scenes'],
        ]
    },'/pages/lite-scenes/edit/:id':{
        title: 'H5 Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['H5 Config Scenes'],
        ]
    },'/pages/compare-scenes':{
        title: 'Compare Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['Compare Config Scenes'],
        ]
    },'/pages/compare-scenes/create':{
        title: 'Compare Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['Compare Config Scenes'],
        ]
    },'/pages/compare-scenes/edit/:id':{
        title: 'Compare Config Scenes',
        permission:['outer_faceid_scene_configure'],
        breadcrumb: [
            ['Compare Config Scenes'],
        ]
    },
    '/pages/sub-account-management':{
        'title':'Sub-accounts',
        'permission':['outer_manage_subaccount_ro', 'outer_manage_subaccount_full'],
        'breadcrumb':[
            ['Sub-accounts']
        ]
    },
    '/pages/edit-role/:id':{
        'title':'Edit Role',
        'permission':['outer_manage_subaccount_edit_role'],
        'breadcrumb':[
            ['Sub-accounts','/pages/role-management'],
            ['Edit Role']
        ]
    },
    '/pages/create-role':{
        'title':'Create Role',
        'permission':['outer_manage_subaccount_edit_role'],
        'breadcrumb':[
            ['Sub-accounts','/pages/role-management'],
            ['Create Role']
        ]
    },
    '/pages/role-management':{
        'title':'Role Management',
        'permission':['outer_manage_subaccount_edit_role'],
        'breadcrumb':[
            ['Role Management']
        ]
    },
    '/pages/role/:id/manage-member':{
        'title':'Manage Members',
        'permission':['outer_manage_subaccount_edit_role'],
        'breadcrumb':[
            ['Role Management','/pages/role-management'],
            ['Manage Members']
        ]
    },
    '/pages/create-sub-account':{
        'title':'Create Sub-account',
        'permission':['outer_manage_subaccount_full'],
        'breadcrumb':[
            ['Sub-accounts','/pages/sub-account-management'],
            ['Create Sub-account']
        ]
    },
    '/pages/edit-subaccount/:id':{
        'title':'Edit Sub-account',
        'permission':['outer_manage_subaccount_full', 'outer_manage_subaccount_ro'],
        'breadcrumb':[
            ['Sub-accounts','/pages/sub-account-management'],
            ['Edit Sub-account']
        ]
    },
    '/pages/bind_apikey':{
        'title':'Bind AppKey',
        'permission':['outer_manage_subaccount_full','outer_manage_subaccount_ro'],
        'breadcrumb':[
            ['Subaccount AppKey']
        ]
    },
    '/pages/auth-brief':{
        'title':'Authorization Overview',
        'permission':['outer_permission_brief'],
        'breadcrumb':[
            ['Authorization Overview']
        ]
    },

};



// WEBPACK FOOTER //
// ./src/utils/routerConfig.js